// components/ui/Field.jsx
import { Fragment } from "react";

export const Field = ({ label, children, required = false, error = null }) => (
  <label className="f-field">
    <div className="f-label">
      {label}
      {required && <span className="required" aria-label="required">*</span>}
    </div>
    {children}
    {error && (
      <div className="field-error" role="alert" aria-live="polite">
        {error}
      </div>
    )}
  </label>
);

export const Tab = ({ id, active, onClick, children }) => (
  <button 
    className={`tab-btn ${active ? "active" : ""}`} 
    onClick={() => onClick(id)} 
    type="button"
    role="tab"
    aria-selected={active}
    tabIndex={active ? 0 : -1}
  >
    {children}
  </button>
);